import React, { ReactElement, createContext, useMemo, useState } from "react";

const getMenuContextValue = (
  isOpen = false,
  setIsOpen: ((value: boolean) => void) | null = null,
) => ({
  isOpen,
  closeMenu: () => {
    setIsOpen?.(false);
  },
  toggleMenu: () => {
    setIsOpen?.(!isOpen);
  },
});

const MenuContext = createContext(getMenuContextValue());

const MenuProvider = ({ children }: { children: ReactElement | undefined }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contextValue = useMemo(() => getMenuContextValue(isOpen, setIsOpen), [isOpen]);
  return <MenuContext.Provider value={contextValue}>{children}</MenuContext.Provider>;
};

export { MenuContext, MenuProvider };
